import React from "react";
import { LockKeyhole } from "lucide-react";
import { getDisplayFileName } from "../../utils/fileName";

// Wave 3 — password prompt for classified (CONFIDENTIAL/SECRET) documents.
// The password is only ever POSTed to the authorized /access endpoint via
// fetchFileBlob — never placed in a URL. Escape cancels (when not busy);
// Enter verifies; the input auto-focuses.
const PasswordPromptModal = ({
  open,
  file,
  value,
  error,
  busy = false,
  onChange,
  onVerify,
  onCancel,
}) => {
  if (!open) return null;

  return (
    <div className="file-card__modal-overlay">
      <div
        className="file-card__modal-panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="file-card-password-title"
        onKeyDown={(event) => {
          if (event.key === "Escape" && !busy && onCancel) {
            event.stopPropagation();
            onCancel();
          }
        }}
      >
        <h3 id="file-card-password-title">
          <LockKeyhole size={20} aria-hidden="true" /> Enter Password for{" "}
          {getDisplayFileName(file)}
        </h3>
        <input
          type="password"
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && onVerify?.()}
          disabled={busy}
          placeholder="Enter password"
          autoFocus
          className="file-card__modal-input"
          aria-label="File password"
        />
        <div className="file-card__modal-actions">
          <button onClick={onVerify} disabled={busy}>
            {busy ? "Verifying..." : "Verify"}
          </button>
          <button onClick={onCancel} disabled={busy}>
            Cancel
          </button>
        </div>
        {error && <p className="file-card__modal-error">{error}</p>}
      </div>
    </div>
  );
};

export default PasswordPromptModal;
